import { useEffect, useState } from "react";
import { getCatalogSettings } from "../lib/publicConfig";

/**
 * The admin-set delivery and returns copy.
 *
 * Returns `null` until it arrives so callers can fall back to their own text
 * rather than flashing an empty policy section.
 */
export function useCatalogSettings() {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    let active = true;
    getCatalogSettings().then((data) => { if (active) setSettings(data || null); });
    return () => { active = false; };
  }, []);
  return settings;
}

export default useCatalogSettings;
